import { UserPermission, useNotify } from '@globaleris/ui.library'
import { Button } from '@material-ui/core'
import ButtonWithPermissions from '../../../components/buttonWithPermissions/buttonWithPermissions'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { EnumTipoLead } from '../../../api/oData/enums/enumTipoLead'
import Page from '../../../components/page/page'
import PageCenterColumn from '../../../components/page/pageCenterColumn'
import PageHeader from '../../../components/page/pageHeader'
import TabsWithPermissions, {
  Tab
} from '../../../components/tabsWithPermissions/tabsWithPermissions'
import { enumToMapValues, enumTranslateOption, MapToArray } from '../../../helpers'
import { hasPermission } from '../../../helpers/permissionsHelper'
import { useConfirmationDialog, usePageState } from '../../../hooks'
import { NonAuthRoutes } from '../../../model'
import { ConfirmationDialogs } from '../../../model/enums/confirmationDialogs'
import { Resources } from '../../../model/RBAC/constants'
import { storeActiveTabForCurrentPage } from '../../../redux'
import { EnumLeadFileTabs } from '../leads.model'
import { deleteLeadById } from '../leads.service'
import { LeadsFileContractTab } from './components/contractTab/leads.file.contractTab'
import { LeadsFileGeneralTab } from './components/generalTab/leads.file.generalTab'

interface LeadsFilePageProps {
  location?: {
    state: {
      leadId?: number
    }
  }
}

export const LeadsFilePage: React.FC<LeadsFilePageProps> = props => {
  const [t] = useTranslation(['globalerisLibrary', 'leads', 'enums', 'sharedTranslations'])
  const history = useHistory()
  const { info, error } = useNotify()
  const { activeTab } = usePageState()
  const { getConfirmation, closeConfirmation } = useConfirmationDialog()

  const [currentTab, setCurrentTab] = useState<number | undefined>(activeTab ?? 0)
  const [subtitle, setSubtitle] = useState<string>('')
  const [hasQuotes, setHasQuotes] = useState<boolean>(false)
  const [isFetchingQuotes, setIsFetchingQuotes] = useState<boolean>(true)

  const leadId = props.location?.state?.leadId
  if (!leadId) {
    history.goBack()
    return <></>
  }

  // #region Handlers Starts
  const handleLeadFileSubtitle = (leadType: EnumTipoLead) => {
    setSubtitle(enumTranslateOption(leadType, EnumTipoLead, 'enums:EnumTipoLead'))
  }

  const handleDeleteLead = async () => {
    await getConfirmation(ConfirmationDialogs.DELETE_LEAD)
    await deleteLeadById(leadId).then(response => {
      if (response.success) {
        info(t('leads:notifications.deleteLead.success'))
        history.push(NonAuthRoutes.Leads)
      } else {
        error(t('leads:notifications.deleteLead.error'))
      }
    })
    closeConfirmation()
  }
  // #endregion Handlers Ends

  // #region Functions Starts
  // #endregion Functions Ends

  // #region Form Definition Starts
  // #endregion Form Definition Ends

  // #region DataTable Config Starts
  // #endregion DataTable Config Ends

  // #region Tabs Definition Starts
  const leadFileTabsArray = MapToArray(enumToMapValues(EnumLeadFileTabs))

  const tabsDefinition: Map<number, Tab> = new Map(
    leadFileTabsArray.map((leadTab, tabIndex) => [
      tabIndex,
      {
        id: leadTab.value,
        label: t(`leads:components.leadFile.tabs.${leadTab.name}`),
        hasPermission: hasPermission(Resources.Leads, [
          UserPermission.EDIT,
          UserPermission.READ_ONLY
        ])
      }
    ])
  )

  const onTabChangeHandler = (tab: number) => {
    if (currentTab !== tab) {
      setCurrentTab(tab)
      storeActiveTabForCurrentPage(tab)
    }
  }

  // #endregion Tabs Definition Ends

  // #region Hooks Starts
  // #endregion Hooks Ends

  return (
    <Page>
      <PageHeader title={t('leads:components.leadFile.title')} subtitle={subtitle}>
        <Button
          variant="text"
          color="primary"
          // disabled={isFetchingClient}
          onClick={() => {
            history.push(NonAuthRoutes.Leads)
          }}
        >
          {t('Volver')}
        </Button>
        <ButtonWithPermissions
          size="small"
          color="primary"
          hasPermission={hasPermission(Resources.Leads, [UserPermission.EDIT])}
          disabled={isFetchingQuotes || hasQuotes}
          onClick={handleDeleteLead}
        >
          {t('leads:components.leadFile.actions.delete')}
        </ButtonWithPermissions>
      </PageHeader>
      <PageCenterColumn>
        <LeadsFileGeneralTab
          leadId={leadId}
          onSubtitleMount={handleLeadFileSubtitle}
          onQuotesLoad={hasQuotes => {
            setHasQuotes(hasQuotes)
            setIsFetchingQuotes(false)
          }}
        />

        {/* ---- This code will remain intentionally in case another Tab needs to be added ---- */
        /* <TabsWithPermissions
          tabs={tabsDefinition}
          tabDefault={currentTab}
          onTabChange={onTabChangeHandler}
        />
        {currentTab !== undefined &&
        leadFileTabsArray[currentTab].value === EnumLeadFileTabs.GENERAL ? (
          <LeadsFileGeneralTab leadId={leadId} onSubtitleMount={handleLeadFileSubtitle} />
        ) : (
          <LeadsFileContractTab />
        )} */}
      </PageCenterColumn>
    </Page>
  )
}
